import React from 'react';
import {useTranslation} from "react-i18next";
import {ReactComponent as MenuItemIco} from "../../../../../images/icons/menus/menu-item.svg";
import {ReactComponent as MenuItemDarkIco} from "../../../../../images/icons/menus/menu-item-dark.svg";
import AppConfig from "../../../../services/AppConfig";

interface Props {
    product: Record<string, any>;
    isProductAvailable: boolean;
}

const MenuProductImages = ({product, isProductAvailable}: Props) => {
    const {t} = useTranslation();

    return (
        <div className={`product-images-container ${isProductAvailable ? "" : "disabled"}`}>
            <div className="product-image-container">
                {
                    product.image_large ?
                        <img src={product.image_large} alt={t("common.word.product_image")}/> : (
                            AppConfig.isDarkMode() ? <MenuItemDarkIco className="product-image"/> :
                                <MenuItemIco className="product-image"/>
                        )
                }
            </div>
        </div>
    )
}

export default MenuProductImages;